export default "__VITE_ASSET__F6v5H0ls__"